import React from 'react';
import './Project.css';
import ProjectCard from './ProjectCard';
import { Projects } from './Data';

function Project() {
    return (
        <div className="pl-2 mt-4 social-link-badge-contents">
            <div className="header-text d-flex align-items-center">
                <p className="h3 pr-2"><b>My Projects ⯆</b></p>
            </div>
            <div>
                <div className="projects-wrapper">
                    {
                        Projects.map((item) => (
                            <ProjectCard key={item.key} title={item.title}
                                description={item.description}
                                exploreLinks={item.exploreLinks}
                                technologies={item.technologies} />
                        ))
                    }
                </div>

            </div>
        </div>
    );
}

export default Project;